import { createSlice } from "@reduxjs/toolkit";

/**
 * Restore the saved theme before the first render.
 *
 * `setDark` has always written `isDark` to localStorage, but nothing ever read
 * it back: the slice started at `isDark: false` and the `dark` class is only
 * added by the reducer, so every reload dropped the user back to light with
 * the navbar toggle showing light too. The value was being saved and never
 * used.
 *
 * The body class is applied here rather than in a component effect so the page
 * never paints light first and then flips.
 */
const readStoredDark = () => {
    try {
        return localStorage.getItem("isDark") === "true";
    } catch {
        // Safari in private mode throws on localStorage access rather than
        // returning null. A theme is not worth failing the boot over.
        return false;
    }
};

const initialIsDark = readStoredDark();
if (initialIsDark) {
    document.querySelector("body")?.classList.add("dark");
}

const uiSlice = createSlice({
    name: "ui",
    initialState: {
        sideBarIsVisiable: false,
        isDark: initialIsDark,
    },
    reducers: {
        toggleSideBar(state) {
            state.sideBarIsVisiable = !state.sideBarIsVisiable;
        },
        setDark(state) {
            state.isDark = true;
            try {
                localStorage.setItem("isDark", "true");
            } catch {
                // See readStoredDark — the toggle still works for this session.
            }
            document.querySelector("body").classList.add("dark");
        },
        setLight(state) {
            state.isDark = false;
            try {
                localStorage.removeItem("isDark");
            } catch {
                // See readStoredDark.
            }
            document.querySelector("body").classList.remove("dark");
        },
    },
});
export const uiSliceActions = uiSlice.actions;
export default uiSlice;
